export const settings = {
  appName: 'Glyphic'
}